// @flow

import type { PropsSchema, BasicProps, EasyAction } from '../../type'

import * as React from 'react'
import css from './Fixed.scss'
import onClickEvents from '../hoc/onClickEvent'
import computeData from '../hoc/computeData'
import { setFixedHeight } from '../../redux/fixedHeight'
import * as browserEnv from 'frame/core/browserEnv'

import $ from 'jquery'

type Position = 'top' | 'bottom';

type Props = BasicProps & {
  style: { [string]: string },
  children: React.ChildrenArray<React.Node>,
  position: Position,
  onClick: () => void
};

type State = {
  updatingPosition: boolean
};

@computeData()
@onClickEvents
export default class Fixed extends React.PureComponent<Props, State> {
  static schema: PropsSchema = [
    {
      type: 'select',
      key: 'position',
      title: '位置',
      options: [['top', '固顶'], ['bottom', '固底']],
      defaultValue: 'top'
    },
    'separator',
    {
      type: 'style'
    }
  ];

  static defaultProps = {
    position: 'top'
  };
  static actions: EasyAction[] = [
    {
      title: '滚动到可见位置',
      name: 'scrollIntoView'
    }
  ];
  state = { updatingPosition: false };

  actionScrollIntoView = () => {
    if (!browserEnv.isInIOS()) return
    this.refs.wrapperedFixed.actionScrollIntoView()
  };

  componentWillReceiveProps (newProps: Props) {
    if (newProps.position !== this.props.position) {
      this.setState({ updatingPosition: true }, () => {
        this.setState({ updatingPosition: false })
      })
    }
  }

  render () {
    if (!this.props.visible || this.state.updatingPosition) {
      return null
    }
    return <WrapperedFixed ref='wrapperedFixed' {...this.props} />
  }
}

class WrapperedFixed extends React.PureComponent<Props> {
  element: ?HTMLElement;

  getStyle () {
    const { position } = this.props

    return {
      top: position === 'top' ? 0 : 'auto',
      bottom: position === 'bottom' ? 0 : 'auto',
      right: 0,
      left: 0,
      height: 'auto'
    }
  }

  componentDidMount () {
    const containerElement = document.getElementById('easy-comp-container')
    if (containerElement) {
      containerElement.appendChild(this.refs.fixedElement)
    }

    setFixedHeight({
      [this.props.position]: $(this.refs.fixedElement).outerHeight()
    })
  }

  componentWillUnmount () {
    const containerElement = document.getElementById('easy-comp-container')
    if (containerElement) {
      containerElement.removeChild(this.refs.fixedElement)
    }

    setFixedHeight({ [this.props.position]: 0 })
  }

  actionScrollIntoView = () => {
    let target = this.refs.fixedElement
    setTimeout(() => {
      target.scrollIntoView(true)
    }, 200)
  };

  render () {
    const { id, onClick, children, style } = this.props
    return (
      <div>
        <div
          className={css.main}
          style={this.getStyle()}
          id={id}
          onClick={onClick}
          ref='fixedElement'
        >
          <div style={style}>{children}</div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Fixed.js